import Box from "@mui/material/Box";
import {Stack} from "@mui/material";

import StakeCard from "../../components/Farms/StakeCard";
export default function Farms() {
    return          <Box sx={{maxWidth: 600, margin: "0 auto"}}>
        <Stack spacing={2}>
            <StakeCard/>
            <StakeCard></StakeCard>
            <StakeCard></StakeCard>
        </Stack>
    </Box>
}